export interface TrustBarItem {
  icon: string;
  text: string;
  subtext?: string;
}

export interface TrustBarProps {
  items: TrustBarItem[];
}

export default function TrustBar({ items }: TrustBarProps) {
  return (
    <section className="bg-charcoal py-5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-6 md:gap-4">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              {i > 0 && (
                <div className="hidden md:block w-px h-8 bg-white/10"></div>
              )}
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${item.icon} text-bronze text-xl`}></i>
                </div>
                <div>
                  <p className="text-white text-sm font-medium whitespace-nowrap">{item.text}</p>
                  {item.subtext && (
                    <p className="text-white/50 text-xs whitespace-nowrap">{item.subtext}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
